// extracted by mini-css-extract-plugin
export default {"root":"Terms_root__6d5NB","container":"Terms_container__z2ZK7","header":"Terms_header__YSZoj","terms":"Terms_terms__LXbhe","terms_sep":"Terms_terms_sep__V7gID"};